import { isEmpty } from '../../../utils'
import projectInfo from '../../../utils/project-info'
import Store from '../../../utils/catch-state'
import { moneyFormat } from './utils'
export const numberSchemaHandle = {
  handle (node) {
    node.props.min = node.minValue
    node.props.max = node.maxValue
    node.props.fieldType = node._type
    node.props.step = node.counterStep
  },
  customParams: {
    event: {},
    props: {}
  }
}

export const numberProps = {
  value: {
    type: String,
    require: true
  },
  placeholder: {
    type: String
  },

  // 最大长度
  max: {
    type: String
  },
  // 最小长度
  min: {
    type: String
  },

  step: {
    type: [Number, String],
    default: '1'
  },

  precision: {},

  fieldType: {
    type: String,
    default: 'number'
  },

  uiType: {
    type: Number,
    default: 1
  },

  blurCheck: {
    type: Boolean,
    default: false
  },

  controls: {
    type: Boolean,
    default: true
  },

  size: {
    type: String,
    default: 'small'
  },

  isPureText: {
    type: Boolean,
    default: true
  },

  disabled: {
    type: Boolean,
    default: false
  }
}

// 数字金额判断是哪个端是否要进行千分位
export const appTypeThousands = async function (data) {
  let systemRules = {
    priceThousandthPercentileEnabled: false, // 金额是否千分位
    numberThousandthPercentileEnabled: false // 数字是否千分位
  }
  if (projectInfo.query() === 'sur') {
    const res = await Store.thousandthsConversion('getSystemRule').getter()
    systemRules.priceThousandthPercentileEnabled = res['amount_unit_price_thousands_config'] === '0'
    systemRules.numberThousandthPercentileEnabled = res['number_thousands_config'] === '0'
  } else {
    const res = await Store.thousandthsConversion('getSystemRules').getter()
    systemRules.priceThousandthPercentileEnabled = res['amount_unit_price_thousands_config'].value === '0'
    systemRules.numberThousandthPercentileEnabled = res['number_thousands_config'].value === '0'
  }
  if (data === 'currency') {
    return systemRules.priceThousandthPercentileEnabled
  }
  return systemRules.numberThousandthPercentileEnabled
}

async function cb (value) {
  const flag = await appTypeThousands('number')
  return flag ? moneyFormat(value) : value
}

export const initValue = (value) => {
  return isEmpty(value) ? '-' : cb(value)
}